import { ChangeDetectionStrategy, Component } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
	selector: 'app-gdpr',
	templateUrl: './gdpr.component.html',
	styleUrls: ['./gdpr.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslatePipe],
})
export class GdprComponent {
	constructor() {}
}
